import {
  createSchema,
  inviteSchema,
  updateCredentialSchema,
  updateSchema,
} from "@/schemas/schemaUsers";
import { setPath } from "@/services/helpers";
import {
  notifyCreateUserError,
  notifyCreateUserSuccess,
  notifyDisableUserError,
  notifyDisableUserSuccess,
  notifyEnableUserError,
  notifyEnableUserSuccess,
  notifyRemoveUserError,
  notifyRemoveUserSuccess,
  notifyUpdateUserError,
  notifyUpdateUserSuccess,
} from "@/services/notification/notificationUser";
import httpClient from "@/store/httpClient";
import { addrs } from "email-addresses";

const endpoint = "/a/users";

// Actions
const actions = {
  async createItems({ commit }, payload) {
    commit("START_LOADING", "createOps");

    const { error, value } = createSchema.validate(payload);

    if (!error) {
      return httpClient
        .post(endpoint, [value])
        .then((response) => {
          if (response.status === 201) {
            commit("APPEND_ITEMS", response);
            commit("FLUSH_FIELD", "createPayload");
            commit("STOP_LOADING", "createOps");
            notifyCreateUserSuccess();
            commit("HIDE_CREATE_OPS_DIALOG");

            return response;
          }
        })
        .catch((error) => {
          console.log(error);
          commit("STOP_LOADING", "createOps");
          notifyCreateUserError(error);
        });
    } else {
      console.log(error);
      commit("STOP_LOADING", "createOps");
      notifyCreateUserError(error);
    }
  },
  async disableItem({ commit }, payload) {
    commit("START_LOADING", "disableOps");

    httpClient
      .get(`${endpoint}/${payload.id}/disable`)
      .then((response) => {
        if (response.status === 200) {
          commit("UPDATE_ITEMS", response);
          commit("STOP_LOADING", "disableOps");
          notifyDisableUserSuccess();
          commit("HIDE_DISABLE_OPS_DIALOG");
        }
      })
      .catch((error) => {
        console.log(error);
        commit("STOP_LOADING", "disableOps");
        notifyDisableUserError(error);
      });
  },
  async enableItem({ commit }, payload) {
    commit("START_LOADING", "enableOps");

    httpClient
      .get(`${endpoint}/${payload.id}/enable`)
      .then((response) => {
        if (response.status === 200) {
          commit("UPDATE_ITEMS", response);
          commit("STOP_LOADING", "enableOps");
          notifyEnableUserSuccess();
          commit("HIDE_ENABLE_OPS_DIALOG");
        }
      })
      .catch((error) => {
        console.log(error);
        commit("STOP_LOADING", "enableOps");
        notifyEnableUserError(error);
      });
  },
  async inviteItems({ commit }, payload) {
    commit("START_LOADING", "inviteOps");

    console.log(payload);
    let emails = addrs.parseAddressList(payload);
    console.log(emails);

    const { error, value } = inviteSchema.validate(payload);

    if (!error) {
      httpClient
        .post(`${endpoint}/invite`, [value])
        .then((response) => {
          if (response.status === 201) {
            commit("APPEND_ITEMS", response);
            commit("FLUSH_FIELD", "inviteOps");
            commit("STOP_LOADING", "inviteOps");
          }
        })
        .catch((error) => {
          console.log(error);
          commit("STOP_LOADING", "inviteOps");
        });
    } else {
      console.log(error);
      commit("STOP_LOADING", "inviteOps");
    }
  },
  async removeItem({ commit }, payload) {
    commit("START_LOADING", "removeOps");

    httpClient
      .delete(`${endpoint}/${payload.id}`)
      .then((response) => {
        if (response.status === 200) {
          commit("REMOVE_ITEM", response);
          commit("STOP_LOADING", "removeOps");
          notifyRemoveUserSuccess();
          commit("HIDE_REMOVE_OPS_DIALOG");
        }
      })
      .catch((error) => {
        console.log(error);
        commit("STOP_LOADING", "removeOps");
        notifyRemoveUserError(error);
      });
  },
  async retrieveItems({ commit }, params) {
    commit("START_LOADING", "retrieveOps");

    httpClient
      .get(endpoint, { params })
      .then((response) => {
        if (response.status === 200) {
          commit("FLUSH_ITEMS");
          commit("APPEND_ITEMS", response);
          commit("UPDATE_SERVER_ITEMS_LENGTH", response);
          commit("STOP_LOADING", "retrieveOps");
        }
      })
      .catch((error) => {
        console.log(error);
        commit("STOP_LOADING", "retrieveOps");
      });
  },
  async searchItems({ commit }, params) {
    commit("START_LOADING", "searchOps");

    httpClient
      .get(`${endpoint}/search`, { params })
      .then((response) => {
        if (response.status === 200) {
          commit("FLUSH_ITEMS");
          commit("APPEND_ITEMS", response);
          commit("UPDATE_SERVER_ITEMS_LENGTH", response);
          commit("STOP_LOADING", "searchOps");
        }
      })
      .catch((error) => {
        console.log(error);
        commit("STOP_LOADING", "searchOps");
      });
  },
  async updateItem({ commit }, payload) {
    commit("START_LOADING", "updateOps");

    const { error, value } = updateSchema.validate(payload.user);

    if (!error) {
      return httpClient
        .put(`${endpoint}/${payload.id}`, value)
        .then((response) => {
          if (response.status === 200) {
            commit("UPDATE_ITEMS", response);
            commit("STOP_LOADING", "updateOps");
            notifyUpdateUserSuccess();
            commit("HIDE_VIEW_OPS_DIALOG");

            return response;
          }
        })
        .catch((error) => {
          console.log(error);
          commit("STOP_LOADING", "updateOps");
          notifyUpdateUserError(error);
        });
    } else {
      console.log(error);
      commit("STOP_LOADING", "updateOps");
      notifyUpdateUserError(error);
    }
  },
  async updateItemPassword({ commit }, payload) {
    commit("TOGGLE_LOADER");

    console.log(payload);

    // Validate payload
    const { error, value } = updateCredentialSchema.validate(
      payload.credentials
    );

    // Make HTTP call
    if (!error) {
      httpClient
        .post(`${endpoint}/${payload.id}/credentials/change`, value)
        .then((response) => {
          if (response.status == 200) {
            commit("TOGGLE_LOADER");
          }
        })
        .catch((error) => {
          console.log(error);
          commit("TOGGLE_LOADER");
        });
    } else {
      console.log(error);
      commit("TOGGLE_LOADER");
    }
  },
};
// Getters
const getters = {};
// Mutations
const mutations = {
  // Loader operations
  START_LOADING(state, name) {
    state[name].isLoading = true;
  },
  STOP_LOADING(state, name) {
    state[name].isLoading = false;
  },
  //   Dialog operations
  HIDE_CREATE_OPS_DIALOG(state) {
    state.createOps.dialog = false;
  },
  HIDE_DISABLE_OPS_DIALOG(state) {
    state.disableOps.dialog = false;
  },
  HIDE_ENABLE_OPS_DIALOG(state) {
    state.enableOps.dialog = false;
  },
  HIDE_INVITE_OPS_DIALOG(state) {
    state.inviteOps.dialog = false;
  },
  HIDE_REMOVE_OPS_DIALOG(state) {
    state.removeOps.dialog = false;
  },
  HIDE_RESET_OPS_DIALOG(state) {
    state.resetOps.dialog = false;
  },
  HIDE_VIEW_OPS_DIALOG(state) {
    state.viewOps.dialog = false;
  },
  SHOW_CREATE_OPS_DIALOG(state) {
    state.createOps.dialog = true;
  },
  SHOW_DISABLE_OPS_DIALOG(state) {
    state.disableOps.dialog = true;
  },
  SHOW_ENABLE_OPS_DIALOG(state) {
    state.enableOps.dialog = true;
  },
  SHOW_INVITE_OPS_DIALOG(state) {
    state.inviteOps.dialog = true;
  },
  SHOW_REMOVE_OPS_DIALOG(state) {
    state.removeOps.dialog = true;
  },
  SHOW_RESET_OPS_DIALOG(state) {
    state.resetOps.dialog = true;
  },
  SHOW_VIEW_OPS_DIALOG(state) {
    state.viewOps.dialog = true;
  },
  // Data operations
  APPEND_ITEMS(state, response) {
    state.users = []; //Flush array before loading data
    response.data.items.forEach((item) => {
      state.users.push(item);
    });
  },
  BULK_OPS_UPDATE(state, payload) {
    state.bulkPayload = Object.assign((state.bulkPayload = payload));
  },
  FLUSH_ITEMS(state) {
    state.users = [];
  },
  FLUSH_ITEM(state) {
    state.user = Object.assign({}, {});
  },
  FLUSH_FIELD(state, name) {
    state[name] = Object.assign({}, {});
  },
  REMOVE_ITEM(state, response) {
    state.users = state.users.filter(
      (element) => element.id != response.data.id
    );
  },
  POPULATE_ITEM(state, payload) {
    state[payload.form] = Object.assign({}, payload.item);
  },
  UPDATE_ITEM(state, response) {
    let index = state.users.findIndex(
      (element) => element.id == response.data.id
    );
    if (index !== -1) {
      Object.assign(state.users[index], response.data);
    }
  },
  UPDATE_ITEMS(state, response) {
    let index = state.users.findIndex(
      (element) => element.id == response.data.id
    );
    if (index !== -1) {
      Object.assign(state.users[index], response.data);
    }
  },
  //   Pagination operations
  UPDATE_SERVER_ITEMS_LENGTH(state, response) {
    state.retrieveOps.serverItemsLength = response.data.meta.total;
  },
  //   Form operations
  UPDATE_FORM(state, { payload }) {
    setPath(state, payload.form, payload.value);
  },
};
// State
const state = {
  users: [],
  user: {},
  bulkPayload: [],
  createPayload: {},
  invitePayload: [],
  removePayload: {},
  disablePayload: {},
  enablePayload: {},
  resetPayload: {},
  createOps: {
    dialog: false,
    isLoading: false,
  },
  disableOps: {
    dialog: false,
    isLoading: false,
  },
  enableOps: {
    dialog: false,
    isLoading: false,
  },
  inviteOps: {
    dialog: false,
    isLoading: false,
  },
  removeOps: {
    dialog: false,
    isLoading: false,
  },
  resetOps: {
    dialog: false,
    isLoading: false,
  },
  retrieveOps: {
    isLoading: false,
    serverItemsLength: 0,
  },
  searchOps: {
    isLoading: false,
    serverItemsLength: 0,
  },
  updateOps: {
    dialog: false,
    isLoading: false,
  },
  viewOps: {
    dialog: false,
    isLoading: false,
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
